module.exports = __webpack_public_path__ + "static/media/secondareaproduct2.14999e74.jpg";